// extracted by mini-css-extract-plugin
module.exports = {"resultEnd":"ProductListing_resultEnd__1np_Q"};